import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { DEFAULT_MIN_IMAGE_HEIGHT, DEFAULT_MIN_IMAGE_WIDTH, DIALOG_MESSAGE as CORE_DIALOG } from '~/core/constants';
import { FileType } from '~/core/enums';
import { isHeic, isImage, validateImageFile } from '~/core/functions';
import useMainDialogStore, { DIALOG_SIZE } from '~/stores/useMainDialogStore';
var ONE_MEGABYTE_MULTIPLIER = 1024 * 1024;
var ACCEPTED_TYPES_MAP = {
  pdf: [FileType.Pdf],
  jpgAndJpeg: [FileType.Jpeg, FileType.Jpg],
  heicAndHeif: [FileType.Heic, FileType.Heif],
  png: [FileType.Png]
};

/**
 * composable позволяющий валидировать массив файлов.
 *
 * При ошибке открывается диалоговое окно.
 * */
export var useFilesValidation = function useFilesValidation(_ref) {
  var acceptedTypes = _ref.acceptedTypes,
    maxSize = _ref.maxSize,
    maxCount = _ref.maxCount,
    imageBounds = _ref.imageBounds,
    customRules = _ref.customRules;
  var $dialog = useMainDialogStore();
  var acceptedTypesUnref = computed(function () {
    return unref(acceptedTypes);
  });
  var fileTypesErrorList = computed(function () {
    if (!acceptedTypesUnref.value) {
      return '';
    }
    var errorText = '';
    if (acceptedTypesUnref.value.includes('png')) {
      errorText += 'PNG|';
    }
    if (acceptedTypesUnref.value.includes('jpgAndJpeg')) {
      errorText += 'JPG|';
    }
    if (acceptedTypesUnref.value.includes('heicAndHeif')) {
      errorText += 'HEIC|';
    }
    if (acceptedTypesUnref.value.includes('pdf')) {
      errorText += 'PDF|';
    }
    errorText = errorText.slice(0, errorText.length - 1);
    var typesArray = errorText.split('|');
    if (typesArray.length > 1) {
      errorText = "".concat(typesArray.slice(0, typesArray.length - 1).join(', '), " \u0438\u043B\u0438 ").concat(typesArray.slice(-1), ".");
    } else {
      errorText.replace('|', '');
    }
    return errorText;
  });
  var multipleError = computed(function () {
    var multipleErrorText = 'Проверьте размер и формат.\nДолжно быть так:';
    if (maxSize) {
      multipleErrorText += "\n\u2022 \u0434\u043E ".concat(maxSize, " \u041C\u0411");
    }
    if (lazyImageBounds.value) {
      multipleErrorText += "\n\u2022 \u043E\u0442 ".concat(lazyImageBounds.value.width, "x").concat(lazyImageBounds.value.height, " \u043F\u0438\u043A\u0441\u0435\u043B\u0435\u0439");
    }
    if (fileTypesErrorList.value) {
      multipleErrorText += "\n\u2022 ".concat(fileTypesErrorList.value);
    }
    return {
      title: 'Не все файлы загружены',
      text: multipleErrorText
    };
  });
  var lazyImageBounds = computed(function () {
    if (!imageBounds) {
      return;
    }
    return {
      width: imageBounds === 'default' ? DEFAULT_MIN_IMAGE_HEIGHT : unref(imageBounds.maxWidth),
      height: imageBounds === 'default' ? DEFAULT_MIN_IMAGE_WIDTH : unref(imageBounds.maxHeight)
    };
  });
  var allRules = computed(function () {
    var innerRules = [function (file) {
      if (acceptedTypesUnref.value) {
        return getFileTypeError(file, acceptedTypesUnref.value, fileTypesErrorList.value) || true;
      }
      return true;
    }, function (file) {
      if (maxSize) {
        return getFileSizeError(file, unref(maxSize)) || true;
      }
      return true;
    }, (/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!imageBounds) {
                _context.next = 7;
                break;
              }
              _context.next = 3;
              return getImageBoundsError(file, lazyImageBounds.value);
            case 3:
              _context.t0 = _context.sent;
              if (_context.t0) {
                _context.next = 6;
                break;
              }
              _context.t0 = true;
            case 6:
              return _context.abrupt("return", _context.t0);
            case 7:
              return _context.abrupt("return", true);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }())];
    if (customRules) {
      innerRules = [].concat(_toConsumableArray(innerRules), _toConsumableArray(customRules));
    }
    return innerRules;
  });
  function validate(_x2) {
    return _validate.apply(this, arguments);
  }
  function _validate() {
    _validate = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(files) {
      var currentCount,
        validatedFiles,
        errors,
        _iterator,
        _step,
        file,
        errorOccurred,
        _iterator2,
        _step2,
        rule,
        res,
        reducedValidatedFiles,
        _i,
        _errors,
        error,
        _args2 = arguments;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            currentCount = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 0;
            validatedFiles = [];
            errors = [];
            _iterator = _createForOfIteratorHelper(files);
            _context2.prev = 4;
            _iterator.s();
          case 6:
            if ((_step = _iterator.n()).done) {
              _context2.next = 38;
              break;
            }
            file = _step.value;
            errorOccurred = false;
            _iterator2 = _createForOfIteratorHelper(allRules.value);
            _context2.prev = 10;
            _iterator2.s();
          case 12:
            if ((_step2 = _iterator2.n()).done) {
              _context2.next = 27;
              break;
            }
            rule = _step2.value;
            _context2.prev = 14;
            _context2.next = 17;
            return rule(file);
          case 17:
            res = _context2.sent;
            if (res !== true) {
              errors.push(res);
              errorOccurred = true;
            }
            _context2.next = 25;
            break;
          case 21:
            _context2.prev = 21;
            _context2.t0 = _context2["catch"](14);
            errors.push(CORE_DIALOG.BASE_ERROR);
            errorOccurred = true;
          case 25:
            _context2.next = 12;
            break;
          case 27:
            _context2.next = 32;
            break;
          case 29:
            _context2.prev = 29;
            _context2.t1 = _context2["catch"](10);
            _iterator2.e(_context2.t1);
          case 32:
            _context2.prev = 32;
            _iterator2.f();
            return _context2.finish(32);
          case 35:
            if (!errorOccurred) {
              validatedFiles.push(file);
            }
          case 36:
            _context2.next = 6;
            break;
          case 38:
            _context2.next = 43;
            break;
          case 40:
            _context2.prev = 40;
            _context2.t2 = _context2["catch"](4);
            _iterator.e(_context2.t2);
          case 43:
            _context2.prev = 43;
            _iterator.f();
            return _context2.finish(43);
          case 46:
            if (errors.length > 1) {
              errors = [multipleError.value];
            }
            reducedValidatedFiles = validatedFiles;
            if (maxCount) {
              reducedValidatedFiles = validatedFiles.slice(0, unref(maxCount) - currentCount);
              if (validatedFiles.slice(reducedValidatedFiles.length, validatedFiles.length).length) {
                errors.push({
                  text: "\u041C\u043E\u0436\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C ".concat(unref(maxCount), " \u0444\u0430\u0439\u043B\u043E\u0432.")
                });
              }
            }
            _i = 0, _errors = errors;
          case 50:
            if (!(_i < _errors.length)) {
              _context2.next = 60;
              break;
            }
            error = _errors[_i];
            _context2.next = 54;
            return $dialog.open(error);
          case 54:
            $dialog.close();
            _context2.next = 57;
            return nextTick();
          case 57:
            _i++;
            _context2.next = 50;
            break;
          case 60:
            return _context2.abrupt("return", reducedValidatedFiles);
          case 61:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 40, 43, 46], [10, 29, 32, 35], [14, 21]]);
    }));
    return _validate.apply(this, arguments);
  }
  return {
    validate: validate
  };
};
var getFileTypeError = function getFileTypeError(file, acceptedTypesKeys, typesErrorText) {
  var targetFileType = file.type;
  var acceptedTypesValues = acceptedTypesKeys.reduce(function (res, type) {
    return [].concat(_toConsumableArray(res), _toConsumableArray(ACCEPTED_TYPES_MAP[type]));
  }, []);
  if (acceptedTypesValues.includes(targetFileType)) {
    return null;
  }
  return {
    title: 'Неподходящий формат',
    text: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 ".concat(typesErrorText),
    size: DIALOG_SIZE.XS
  };
};
var getImageBoundsError = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(file, _ref3) {
    var width, height;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          width = _ref3.width, height = _ref3.height;
          _context3.t0 = isImage(file) && !isHeic(file);
          if (!_context3.t0) {
            _context3.next = 6;
            break;
          }
          _context3.next = 5;
          return validateImageFile(file, {
            width: width,
            height: height
          });
        case 5:
          _context3.t0 = !_context3.sent;
        case 6:
          if (!_context3.t0) {
            _context3.next = 8;
            break;
          }
          return _context3.abrupt("return", {
            title: 'Слишком маленькое фото',
            text: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u043E\u0442\u043E \u043E\u0442 ".concat(width, "x").concat(height, " \u043F\u0438\u043A\u0441\u0435\u043B\u0435\u0439.")
          });
        case 8:
          return _context3.abrupt("return", null);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getImageBoundsError(_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();
var getFileSizeError = function getFileSizeError(file, maxSize) {
  if (file.size > maxSize * ONE_MEGABYTE_MULTIPLIER) {
    return {
      title: 'Слишком большой файл',
      text: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0434\u043E ".concat(maxSize, " \u041C\u0411."),
      size: DIALOG_SIZE.XS
    };
  }
  return null;
};